module.exports = __webpack_public_path__ + "img/70200.3247e5f2.jpg";